<template>
  <div>
    <DxTabs
      v-if="showTabs"
      :data-source="tabs"
      :selected-index="selectedIndex"
      :on-item-click="itemClick"
      :focusStateEnabled="true"
    />
  </div>
</template>

<script>
export default {
  props: {
    selectedIndex: Number,
    tabs: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  computed: {
    showTabs() {
      return this.tabs.length > 0;
    },
    tabOptions() {
      return {
        dataSource: this.tabs,
        onItemClick: this.itemClick,
        selectedIndex: this.selectedIndex,
        showNavButtons: true,
        scrollByContent: true,
        width: this.isXSmall ? this.calculatedTabWidth + "px" : "auto",
      };
    },
  },
  methods: {
    itemClick(e) {
      if (e.itemData.path == "") {
        return;
      }

      // eslint-disable-next-line no-debugger
      this.$router.push({
        path: e.itemData.path,
      });
    },
  },
};
</script>

<style lang="scss">
.dx-tabs,
.dx-tab {
  background-color: #ffffff;
}

.dx-tab-content {
  padding: 0 5px;
}

.dx-tab-content,
.dx-tab-text {
  text-transform: none !important;
}
</style>
